import React, { useMemo } from "react";
import { isString } from "@common/helpers/typeGuards";
import {
    isRuleConditionSimilarTo,
    parseSimilarToValue,
} from "@common/helpers/split-aware-description.helper";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    condition: TransactionRuleCondition;
    normalizedDescriptions: NormalizedDescriptionInfo[];
}

export const RuleSimilarToCondition: React.FC<Props> = ({
    condition,
    normalizedDescriptions,
}) => {
    const label = useMemo(() => {
        if (
            !isString(condition.value) &&
            !isRuleConditionSimilarTo(condition.value)
        ) {
            return null;
        }

        const { normalizedDescriptionId } = parseSimilarToValue(
            condition.value,
        );

        const desc = normalizedDescriptions.find(
            (d) => d.id === normalizedDescriptionId,
        );

        return desc?.normalizedDescription ?? normalizedDescriptionId;
    }, [condition.value, normalizedDescriptions]);

    if (!label) {
        return null;
    }

    return <RuleTagRow label="Similar to" type="condition" values={[label]} />;
};
